import { requestPerDiemForDateApi } from './graphql/requestPerDiemWithDateApi';
import { requestPerDiemApi } from './graphql/requestPerDiemApi';
import { approvePerDiemApi } from './graphql/approvePerDiemRequestApi';
import { denyPerDiemApi } from './graphql/denyPerDiemRequestApi';
import { reclaimPerDiemApi } from './graphql/reclaimPerDiemApi';
import { retryPayingPerDiemApi } from './graphql/retryPayingPerDiemApi';
import {
  getBeforePageSize,
  getDistrictId, getFirstPageSize, getNextCursor, getPageSize,
  getPerDiemId,
  getPerDiems,
  getPerDiemState, getPrevCursor, getSorted,
  getTicketJobNumber,
  getUserId,
} from './selectors';

export const types = {
  SET_DISTRICT: 'perDiems/SET_DISTRICT',
  SET_DEPARTMENT: 'perDiems/SET_DEPARTMENT',
  SET_PER_DIEM_ID: 'perDiems/SET_PER_DIEM_ID',
  SET_PER_DIEM_STATE: 'perDiems/SET_PER_DIEM_STATE',
  SET_USER: 'perDiems/SET_USER',
  SET_TICKET_JOB_NUMBER: 'perDiems/SET_TICKET_JOB_NUMBER',
  SET_PAGE_SIZE: 'perDiems/SET_PAGE_SIZE',
  SET_NEXT_CURSOR: 'perDiems/SET_NEXT_CURSOR',
  SET_PREV_CURSOR: 'perDiems/SET_PREV_CURSOR',
  SET_TABLE_ORDER: 'perDiems/SET_TABLE_ORDER',
  SET_REQUESTED_AT_DATE: 'perDiems/SET_REQUESTED_AT_DATE',
  SET_REQUESTED_FOR_DATE: 'perDiems/SET_REQUESTED_FOR_DATE',
  SET_PAYMENT_DATE: 'perDiems/SET_PAYMENT_DATE',
  SET_FILTERING_VALUES: 'perDiems/SET_FILTERING_VALUES',
  CLEAR_FILTERING_VALUES: 'perDiems/CLEAR_FILTERING_VALUES',
  SET_TABLE_DATA_REQUEST: 'perDiems/SET_TABLE_DATA_REQUEST',
};

export const setDistrict = (district) => {
  return {
    type: types.SET_DISTRICT,
    district,
  };
};

export const setDepartment = (department) => {
  return {
    type: types.SET_DEPARTMENT,
    department,
  };
};

export const setPerDiemId = (perDiemId) => {
  return {
    type: types.SET_PER_DIEM_ID,
    perDiemId,
  };
};

export const setPerDiemState = (perDiemState) => {
  return {
    type: types.SET_PER_DIEM_STATE,
    perDiemState,
  };
};

export const setUser = (user) => {
  return {
    type: types.SET_USER,
    user,
  };
};

export const setTicketJobNumber = (ticketJobNumber) => {
  return {
    type: types.SET_TICKET_JOB_NUMBER,
    ticketJobNumber,
  };
};

export const setRequestedAtDate = (requestedAt) => {
  return {
    type: types.SET_REQUESTED_AT_DATE,
    requestedAt,
  };
};

export const setRequestedForDate = (requestedForDate) => {
  return {
    type: types.SET_REQUESTED_FOR_DATE,
    requestedForDate,
  };
};

export const setPaymentDate = (paymentDate) => {
  return {
    type: types.SET_PAYMENT_DATE,
    paymentDate,
  };
};

export const setTableDataRequest = (tableDataRequest) => {
  return {
    type: types.SET_TABLE_DATA_REQUEST,
    tableDataRequest,
  };
};

export const setFilteringValues = (filteringValues) => {
  return {
    type: types.SET_FILTERING_VALUES,
    filteringValues,
  };
};

export const clearFilteringValues = () => {
  return {
    type: types.CLEAR_FILTERING_VALUES,
  };
};

export const requestPerDiemWithDate = (perDiemRequestInput) => {
  return async (dispatch, getState, { client }) => {
    return requestPerDiemForDateApi(client, perDiemRequestInput);
  };
};

export const requestPerDiem = (perDiemRequestInput) => {
  return async (dispatch, getState, { client }) => {
    return requestPerDiemApi(client, perDiemRequestInput);
  };
};

const getPageState = (state) => {
  return {
    ...getPerDiems(state),
    currentPageSize: getPageSize(state),
    nextCursor: getNextCursor(state),
    prevCursor: getPrevCursor(state),
    first: getFirstPageSize(state),
    last: getBeforePageSize(state),
    sorted: getSorted(state),
  };
};

export const approvePerDiemRequest = () => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const districtId = getDistrictId(state);
    const userId = getUserId(state);
    const ticketJobNumber = getTicketJobNumber(state);
    const perDiemId = getPerDiemId(state);
    const perDiemState = getPerDiemState(state);
    const approvePerDiemInput = { per_diem_id: perDiemId };
    const pageState = getPageState(state);

    // eslint-disable-next-line max-len
    return approvePerDiemApi(client, approvePerDiemInput, districtId, perDiemState, userId, ticketJobNumber, pageState);
  };
};

export const denyPerDiemRequest = (denyReason) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const districtId = getDistrictId(state);
    const userId = getUserId(state);
    const ticketJobNumber = getTicketJobNumber(state);
    const perDiemId = getPerDiemId(state);
    const perDiemState = getPerDiemState(state);

    const denyPerDiemInput = { per_diem_id: perDiemId, reason: denyReason };
    const pageState = getPageState(state);

    // eslint-disable-next-line max-len
    return denyPerDiemApi(client, denyPerDiemInput, districtId, perDiemState, userId, ticketJobNumber, pageState);
  };
};

export const reclaimPerDiem = (recliamReason) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const perDiemId = getPerDiemId(state);
    const reversePerDiemInput = { per_diem_id: perDiemId, reason: recliamReason };

    return reclaimPerDiemApi(client, reversePerDiemInput);
  };
};

export const retryPayingPerDiem = () => {
  return async (dispatch, getState, { client }) => {
    const state = await getState();

    const perDiemId = getPerDiemId(state);
    const retryPayingPerDiemInput = { per_diem_id: perDiemId };

    const pageState = getPageState(state);
    return retryPayingPerDiemApi(client, retryPayingPerDiemInput, pageState);
  };
};

// Pagination Actions

export const setPageSize = (pageSize) => {
  return {
    type: types.SET_PAGE_SIZE,
    pageSize,
  };
};

export const setNextCursor = (nextCursor) => {
  return {
    type: types.SET_NEXT_CURSOR,
    nextCursor,
  };
};

export const setPrevCursor = (prevCursor) => {
  return {
    type: types.SET_PREV_CURSOR,
    prevCursor,
  };
};
export const setTableOrder = (sorted) => {
  return {
    type: types.SET_TABLE_ORDER,
    sorted,
  };
};
